import { Inject, Injectable } from '@angular/core';
import { ENV_CONFIG } from '@sc/data-access-environment';
import { Environment } from '@sc/data-access-models';
import {
  ApplicationInsights,
  IApplicationInsights,
} from '@microsoft/applicationinsights-web';
import { nanoid } from 'nanoid';
import { ConfigurationService } from '@sc/data-access-configuration';
import { IEventTelemetry } from '@microsoft/applicationinsights-common/src/Interfaces/IEventTelemetry';
import { IPageViewTelemetry } from '@microsoft/applicationinsights-common/src/Interfaces/IPageViewTelemetry';
import { IExceptionTelemetry } from '@microsoft/applicationinsights-common/src/Interfaces/IExceptionTelemetry';

@Injectable({
  providedIn: 'root',
})
export class InsightService {
  private readonly appInsightsClient: IApplicationInsights;

  private readonly appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: this.env.insightId,
    },
  });

  constructor(
    @Inject(ENV_CONFIG) private readonly env: Environment,
    private readonly configurationService: ConfigurationService
  ) {
    this.appInsightsClient = this.appInsights.loadAppInsights();
  }

  generateRequestId(): string {
    return nanoid(20);
  }

  trackEvent(
    event: IEventTelemetry,
    customProperties: { [key: string]: any } = {}
  ): void {
    this.appInsightsClient.trackEvent(
      event,
      this.addProperties(customProperties)
    );
  }
  trackPageView(
    pageView: IPageViewTelemetry,
    customProperties: { [key: string]: any } = {}
  ): void {
    this.appInsightsClient.trackPageView(
      pageView,
      this.addProperties(customProperties)
    );
  }

  trackException(
    exception: IExceptionTelemetry,
    customProperties: { [key: string]: any } = {}
  ): void {
    this.appInsightsClient.trackException(
      exception,
      this.addProperties(customProperties)
    );
  }

  private addProperties(customProperties: { [key: string]: any }): {
    [key: string]: any;
  } {
    return {
      ...customProperties,
      insurerId: this.configurationService.getConfig()?.id,
      origin: window.location.href,
    };
  }
}
